// Shared contract between the saved-event-ids API route (server) and the
// useSavedEventIds hook (client). Keep this module free of server-only imports
// so it is safe to include in the client bundle.

// The client chunks its requests at this size and the server rejects any
// request larger than it, so they MUST stay equal — a single source of truth
// guarantees that.
export const MAX_EVENT_IDS_PER_REQUEST = 200;

// Defensive upper bound on a single event id. Real ids are short numeric
// strings; anything longer is malformed and is rejected before hydration.
export const MAX_EVENT_ID_LENGTH = 64;

export type SavedEventIdsResponse = { savedEventIds: string[] };
